import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useCategories } from '../context/CategoriesContext';
import { ANIMATION_WORKS, MODEL_WORKS, VFX_WORKS } from '../mock';
import Animation from './Animation';
import Modelling from './Modelling';
import VFX from './VFX';

const SAMPLE_FALLBACK = { animation: ANIMATION_WORKS, modelling: MODEL_WORKS, vfx: VFX_WORKS };
const LAYOUT_PAGES = { video: Animation, model: Modelling, mixed: VFX };

export default function CategoryPage() {
  const { slug } = useParams();
  const { categories, loaded } = useCategories();
  if (!loaded) return null;

  const idx = categories.findIndex((c) => c.key === slug);
  if (idx === -1) return <NoSignal />;

  const category = categories[idx];
  const Page = LAYOUT_PAGES[category.layout] || VFX;
  const input = String(idx + 1).padStart(2, '0');
  return <Page key={category.key} category={category} input={input} fallback={SAMPLE_FALLBACK[category.key]} />;
}

function NoSignal() {
  return (
    <div className="page-in w-full h-full flex flex-col items-center justify-center gap-4 py-20 text-center" data-testid="page-no-signal">
      <div className="font-display text-5xl md:text-6xl text-[#ffe9b8] phosphor-glow">NO SIGNAL</div>
      <div className="font-osd text-sm tracking-widest text-[#a88552]">// THIS CHANNEL IS OFF THE AIR</div>
      <Link to="/" data-testid="no-signal-home-link" className="header-tab font-osd text-sm tracking-widest px-4 py-2 border-2 rounded-sm">
        RETURN TO INPUT SELECT
      </Link>
    </div>
  );
}
